import React from "react";
import forge from "node-forge";
import Api_Call from "../ApiCall";

function convertToPEM(publicKey) {
  // Assuming publicKey is in Base64-encoded format
  const pem = `-----BEGIN PUBLIC KEY-----\n${publicKey}\n-----END PUBLIC KEY-----`;
  return pem;
}

function isBase64Encoded(str) {
  // Regular expression to match Base64-encoded strings
  const base64Regex =
    /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;

  return base64Regex.test(str);
}
function getCharactersAtIndex(string) {
  const characters = [];
  for (let i = 0; i < string.length; i++) {
    characters.push(string.charAt(i));
  }
  return characters;
}
function isPEMPublicKey(publicKey) {
  // Define the expected header and footer
  const expectedHeader = "-----BEGIN PUBLIC KEY-----";
  const expectedFooter = "-----END PUBLIC KEY-----";

  // Check if the string starts with the expected header and ends with the expected footer
  const startsWithHeader = publicKey.startsWith(expectedHeader);
  const endsWithFooter = publicKey.endsWith(expectedFooter);

  // Return true if both conditions are met
  return startsWithHeader && endsWithFooter;
}
function findDifference(string1, string2) {
  const maxLength = Math.max(string1.length, string2.length);
  let difference = "";

  for (let i = 0; i < maxLength; i++) {
    if (string1[i] !== string2[i]) {
      difference += `${string1[i] || "-"} ≠ ${string2[i] || "-"}, `;
    }
  }

  if (difference.length === 0) {
    return "The strings are identical.";
  } else {
    return `The strings differ at positions: ${difference.slice(0, -2)}.`;
  }
}

const charactersPerLine = 66;

class RSATokenGenerator extends React.Component {
  state = {
    publicKey: null,
  };

  async componentDidMount() {
    const api = new Api_Call();
    const data = await api.getData(`GET-PUBLIC-KEY`);
    const publicKey = data.rsaKey;
    console.log(publicKey);
    this.setState({ publicKey });

    // fetch('https://example.com/api/public-key')
    //   .then(response => response.text())
    //   .then(publicKey => {
    //     this.setState({ publicKey });
    //   })
    //   .catch(error => {
    //     console.error('Error fetching public key:', error);
    //   });
  }

  generateToken2 = () => {
    // Generate an RSA key pair
    const rsa = forge.pki.rsa;
    const keyPair = rsa.generateKeyPair({ bits: 2048 });

    // Convert the public key to PEM format
    if (this.state) {
      console.log(this.state);
      // const publicKeyPem = forge.pki.publicKeyToPem(this.state.publicKey);
      //   const publicKeyPem = this.state.publicKey;
      const publicKeyBytes = forge.util.decode64(this.state.publicKey);
      const publicKeyPem = forge.pki.publicKeyFromPem(
        forge.util.decodeUtf8(publicKeyBytes)
      );
      console.log(publicKeyBytes);
      this.setState({
        publicKey: publicKeyPem,
      });
      console.log(publicKeyPem);
      // Generate a random token
      const token = forge.random.getBytesSync(16);

      // Encrypt the token using the public key
      const encryptedToken = forge.pki
        .publicKeyFromPem(publicKeyPem)
        .encrypt(token);

      //   console.log("RSA Public Key:", publicKeyPem);
      console.log("Encrypted Token:", forge.util.bytesToHex(encryptedToken));
    }
  };

  generateToken = () => {
    if (!this.state.publicKey) {
      console.error("Public key not loaded yet");
      return;
    }
    const rsa = forge.pki.rsa;
    const keyPair = rsa.generateKeyPair({ bits: 2048 });

    console.log(forge.pki.publicKeyToPem(keyPair.publicKey));
    console.log(keyPair);

    // const publicKeyPem = convertToPEM(this.state.publicKey);
    const publicKeyPem = `-----BEGIN PUBLIC KEY-----
    MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoxkUqcQ/fITsyX0VcvGW8hAjNh1DNgjDQLP9Yc3aX+5vn9Dt+KxMpvi3WUfuiUpk7TxsJFN0RpdIK/NwkJavR3TPTvHfaGcpR6NOhw/IeoTSmyn+kIb6pTg3GFd/Fd93CwDhfio9Qu0LIpJ9R5sFiBXEYsBd2QjTBFiA/SIWrT0o3zztaWUKx7OM1WQBVYbInt3IIDcXYRjevUdTLKIkV0afuNiADZery50nC/glofvjFDc/1fxb9DcLsoKAfUI0QgV56Y564kMn7KYQzxEElprjb4ynmdQu52YzoP2g3xH4VdTccXDxEDbnJMuBzlzNvKasEnU8qW+ieB9Mmun3bwIDAQAB
    -----END PUBLIC KEY-----`;

    // const publicKeyPem = `-----BEGIN PUBLIC KEY-----
    //  3MB18+CorK2mYFlNexHzJoArPZUZgcPWBUZdPjdW6uiSMgAMyedxO8xGYzqNvF7NLf41OuE25NOdISu1lr6ueD/wxAkpn68o3IRe9UT/nx2yOYSZUim7LRiWCmuLCEWtTDdkP1fvCNqMhZxpwCWQDux5xHCxxeEr10nCbBC7mqTc+SEL8NNu9sih7C8EEU2jREI29KVaHyWJIbEa15zwdM6j8wJ3GvARONhj4sU595RWBbRDNq3SRJZAlzs+aMoJJOLifZbvjyBzUfVqZVrkKKPftZQnbQK/grgwlZwOBi/LyBS96uZKPkGZOcQUgVjJAsUqGR9g8NHTjXIiI5P1AQ==    -----END PUBLIC KEY-----`;
    // console.log(publicKeyPem);
    // const publicKeyBase64 = `    MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoxkUqcQ/fITsyX0VcvGW8hAjNh1DNgjDQLP9Yc3aX+5vn9Dt+KxMpvi3WUfuiUpk7TxsJFN0RpdIK/NwkJavR3TPTvHfaGcpR6NOhw/IeoTSmyn+kIb6pTg3GFd/Fd93CwDhfio9Qu0LIpJ9R5sFiBXEYsBd2QjTBFiA/SIWrT0o3zztaWUKx7OM1WQBVYbInt3IIDcXYRjevUdTLKIkV0afuNiADZery50nC/glofvjFDc/1fxb9DcLsoKAfUI0QgV56Y564kMn7KYQzxEElprjb4ynmdQu52YzoP2g3xH4VdTccXDxEDbnJMuBzlzNvKasEnU8qW+ieB9Mmun3bwIDAQAB
    // `;

    // const token = forge.random.getBytesSync(16);

    const token = forge.random.getBytesSync(16);
    console.log(token);

    console.log(isBase64Encoded(publicKeyPem));
    // const encryptedToken = forge.pki
    //   .publicKeyFromPem(publicKeyPem)
    //   .encrypt(token);
    const encryptedToken1 = forge.pki
      .publicKeyFromPem(forge.pki.publicKeyToPem(keyPair.publicKey))
      .encrypt(token);
    console.log(
      forge.pki.publicKeyFromPem(forge.pki.publicKeyToPem(keyPair.publicKey))
    );
    console.log(encryptedToken1);

    console.log("Encrypted Token:", forge.util.bytesToHex(encryptedToken1));
    // const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);
    const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);

    console.log(publicKey);

    const encryptedToken = forge.pki
      .publicKeyFromPem(publicKeyPem)
      .encrypt(token);
    console.log(encryptedToken);
  };

  render() {
    return (
      <div>
        <button onClick={this.generateToken}>Generate RSA Token</button>
      </div>
    );
  }
}

export default RSATokenGenerator;
